import { format } from 'date-fns';

/**
 * Formata um valor numérico em valor monetário
 */
 export const formatMoney = (value, invertSeparator = false) => {
    if (value === null) return '';
  
    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  
    const final = formatter.format(value);
  
    if (invertSeparator) {
      return final.replace(/,/g, '#').replace(/./g, ',').replace(/#/g, '.');
    }
  
    if (final.includes('-')) {
      const arr = final.replace('-', '').split('');
      arr.splice(3, 0, '-');
      return arr.join('');
    }
  
    return final;
};

/**
 * Transforma um objeto json som url params
 *
 * @param params o json a ser convertido
 * @returns string
 */
 export const jsonToURLParam = (
  params,
  insertDivision = true,
) => {
  if (Object.keys(params).length === 0) return '';

  const result = Object.keys(params)
    .filter((key) => params[key] !== null && params[key] !== '')
    .map((key) => {
      return (
        encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
      );
    })
    .join('&');

  return insertDivision ? `?${result}` : result;
};

/**
 * Formata a data para o formato legível em tela
 */
 export const formatDate = (value) => {
  return value ? format(new Date(value), 'DD/MM/YYYY HH:mm') : '';
};


// WEBPACK FOOTER //
// ./src/components/Pages/Wallet/util.js